import React from "react";
import I18n from "i18n.js.erb";
import { parseShortAddress } from "../../utils/utils";

const STATE_COLORS = {
  idle: '#C2C2C2',
  initialized: '#cbb4fa',
  boot: '#85D6FF',
  check: '#DB7EF3',
  door_opened: '#FF8C00',
  door_closed: '#56C459',
  cells_scan: '#549BF6'
};

// Etichetta tradotta dello stato di un espositore, usata anche dal filtro per stato della dashboard. Se manca la
// traduzione (es. in giapponese) si mostra il nome dello stato
export const expoTotemStateLabel = (state) =>
  state ? I18n.t(`js.loopDashboard.states.${state}`, { defaultValue: state.replace(/_/g, ' ') }).toUpperCase() : '';

const ExpoTotemTile = ({ totem, onSelect, isDimmed, isSingleTotem, isExpanded }) => {
  const address = totem.shipment_address;
  const titleLine = address ? parseShortAddress(address) : null;
  const storeName = totem.store_name;
  const isClickable = Boolean(onSelect) && !isSingleTotem;

  const stateColor = STATE_COLORS[totem.state] || '#C2C2C2';
  const stateLabel = expoTotemStateLabel(totem.state);

  return (
    <div
      className={`loop-totem-row col-12 d-flex my-1 px-0${isDimmed ? ' loop-cell-dimmed' : ''}${isClickable ? ' cursor-pointer' : ''}${isExpanded ? ' loop-totem-row--expanded' : ''}`}
      onClick={isSingleTotem ? undefined : onSelect}
    >
      <div
        className={`row w-100 p-0 m-0 align-items-center border-aiG-light-gray-imp br-8px bg-aig-gradient-light${
          isClickable ? ' cursor-pointer' : ''
        }`}
      >
        {/* Serial number */}
        <div
          className="col-5 col-md-4 col-xl-2 col-xxl-1dot5 bg-aig-gradient color-white
            d-flex justify-content-center align-items-center
            px-0 minH-40px-imp z-index-10 position-relative
            br-top-left-8px br-bottom-left-0px br-bottom-right-8px
            br-bottom-left-md-8px br-bottom-right-md-0px"
        >
          <div className="d-flex align-items-center">
            <b className="font-size-xxxl-16px text-nowrap">{totem.serial_number}</b>
          </div>

          <div className="position-absolute z-index-99 right-negative-18px">
            <div className="d-flex flex-directions-column bg-aig-gradient p-2px br-50perc">
              <div className="d-flex justify-content-center flex-fill align-items-center br-50perc bg-white grading-container-medium">
                <img src="/images/icona-AiGrading.svg" alt="AiGrading" width="20px" />
              </div>
            </div>
          </div>
        </div>

        {/* Center - address + pills (desktop only) */}
        <div className="col-2 col-md-4 col-xl-8 col-xxl-9 z-index-10 px-0">
          <div className="d-none d-xl-flex justify-content-between align-items-center px-0 px-md-2 px-xl-4">
            <span className="loop-totem-row__address">
              {titleLine || storeName || '—'}
            </span>

            <div className="d-flex loop-totem-row__pills">
              {storeName && (
                <span className="loop-totem-row__pill">
                  {storeName}
                </span>
              )}

              <span className="loop-totem-row__pill">
                <img src="/images/loop-error-cell.png" alt="" className="loop-totem-row__pill-icon" />
                {totem.error_cells_count} {I18n.t('js.loopDashboard.error').toUpperCase()}
              </span>

              <span className="loop-totem-row__pill">
                <img src="/images/loop-cell.png" alt="" className="loop-totem-row__pill-icon" />
                {totem.occupied_cells_count} {I18n.t('js.loopDashboard.cells').toUpperCase()}
              </span>
            </div>
          </div>
        </div>

        {/* State */}
        <div
          className="col-5 col-md-4 col-xl-2 col-xxl-1dot5 px-0 color-white
            d-flex justify-content-center align-items-center text-center
            minH-40px-imp z-index-99 position-relative
            br-top-right-8px br-bottom-left-8px br-bottom-right-0px
            br-bottom-left-md-0px br-bottom-right-md-8px"
          style={{ backgroundColor: stateColor }}
        >
          <img
            src={`/images/icons/white/expo_totems/states/${totem.state}.svg`}
            alt=""
            className="mr-2"
            style={{ maxHeight: '18px' }}
          />
          <b className="mt-1 text-nowrap">{stateLabel}</b>
        </div>

        {/* Address + pills (mobile/tablet) */}
        <div className="col-12 d-block d-md-flex d-xl-none justify-content-between align-items-center py-2 pr-1 text-center text-md-left">
          <span className="loop-totem-row__address">
            {titleLine || storeName || '—'}
          </span>

          <div className="d-flex justify-content-center justify-content-md-end loop-totem-row__pills mt-1 mt-md-0">
            {storeName && (
              <span className="loop-totem-row__pill">
                {storeName}
              </span>
            )}

            <span className="loop-totem-row__pill">
              <img src="/images/loop-error-cell.png" alt="" className="loop-totem-row__pill-icon" />
              {totem.error_cells_count} {I18n.t('js.loopDashboard.error').toUpperCase()}
            </span>

            <span className="loop-totem-row__pill">
              <img src="/images/loop-cell.png" alt="" className="loop-totem-row__pill-icon" />
              {totem.occupied_cells_count} {I18n.t('js.loopDashboard.cells').toUpperCase()}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ExpoTotemTile;
